
import React, { useContext, useEffect, useState } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import { db } from '../firebase/firebase-config';
import { collection, getDocs, doc } from 'firebase/firestore';
import firebase from "../firebase/firebase-config";
import GoogleLogin, { GoogleLogout } from 'react-google-login';
import Logo from '../assets/img/logo_main.png';
import { gapi } from 'gapi-script';
import { addDays } from "date-fns";





// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment/moment";
import { Chart } from 'chart.js';
import DayVisitsReport from "../components/Reports/dayVisitsReport";
import { GoogleLoginContext } from "../contexts/GoogleLoginContext";
import CountriesReport from "../components/Reports/countriesReport";
import PageviewsReport from "../components/Reports/pageviewReport";
import SourceReport from "../components/Reports/sourceReport";
import DevicesReport from "../components/Reports/devicesReport";
import PivotTable from "../components/Reports/PivotTableReport";
import CustomDatePicker from "../components/Reports/datepicker";


// import 'chartjs-adapter-date-fns';
// import { Redirect } from "react-router-dom";

const Dashboard = (props) => {

  let formatter = Intl.NumberFormat('en', { notation: 'compact' });

  const [User_Data, setUser_Data] = useState([]);
  const [total_users, settotal_users] = useState(0);
  const [total_orders, settotal_orders] = useState(0);
  const [beyownTotalRevenue, SetbeyownTotalRevenue] = useState(0);
  const [total_products, settotal_products] = useState(0);
  const [beyown_monthly_earnings_months, setTotal_beyown_monthly_earnings_months] = useState([])
  const [beyown_monthly_earnings, setTotal_beyown_monthly_earnings] = useState([])
  const [beyown_monthly_Sales, setbeyown_monthly_Sales] = useState([])
  // const [AdsRevDates, setAdsRevDates] = useState([])
  const [AdsRevDatesEarning, setAdsRevDatesEarning] = useState(0)
  const [total_orders_data, settotalOrdersData] = useState({
    JAN: 0,
    FEB: 0,
    MAR: 0,
    APR: 0,
    MAY: 0,
    JUN: 0,
    JUL: 0,
    AUG: 0,
    SEP: 0,
    OCT: 0,
    NOV: 0,
    DEC: 0
  });

  const [order_chart, setorder_chart] = useState({
    JAN: 0,
    FEB: 0,
    MAR: 0,
    APR: 0,
    MAY: 0,
    JUN: 0,
    JUL: 0,
    AUG: 0,
    SEP: 0,
    OCT: 0,
    NOV: 0,
    DEC: 0
  });



  const [order_status_chart, setorder_status_chart] = useState({
    pending: 0,
    approved: 0,
    production: 0,
    out_delivery: 0,
    delivered: 0
  })

  const [sale_dates, setsale_dates] = useState([])
  const [total_Sales, settotal_Sales] = useState(0)
  const [beyown_total_sales, Setbeyown_Total_sales] = useState(0);
  // const [startDate, setStartDate] = useState(new Date().getFullYear());
  // const [endDate, setEndDate] = useState(new Date().getFullYear());
  const getData = async () => {
    const get_users = await firebase.firestore().collection('users');
    get_users.onSnapshot((data) => {
      settotal_users(data.size);
    })

    const get_orders = await firebase.firestore().collection('orders');
    get_orders.onSnapshot((data) => {
      settotal_orders(data.size);


    })


    const get_products = await firebase.firestore().collection('post');
    get_products.onSnapshot((data) => {
      settotal_products(data.size);


    })
    // GETTING TOTAL ORDERS

    firebase.firestore().collection('orders').where('month', '==', 'January').onSnapshot((data) => {
      setorder_chart(prev => { return { ...prev, JAN: data.size } });

    })
    firebase.firestore().collection('orders').where('month', '==', 'Febuary').onSnapshot((data) => {

      setorder_chart(prev => { return { ...prev, FEB: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'March').onSnapshot((data) => {
      setorder_chart(prev => { return { ...prev, MAR: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'April').onSnapshot((data) => {

      setorder_chart(prev => { return { ...prev, APR: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'May').onSnapshot((data) => {

      setorder_chart(prev => { return { ...prev, MAY: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'June').onSnapshot((data) => {

      setorder_chart(prev => { return { ...prev, JUN: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'July').onSnapshot((data) => {

      setorder_chart(prev => { return { ...prev, JUL: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'August').onSnapshot((data) => {

      setorder_chart(prev => { return { ...prev, AUG: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'September').onSnapshot((data) => {
      setorder_chart(prev => { return { ...prev, SEP: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'October').onSnapshot((data) => {

      setorder_chart(prev => { return { ...prev, OCT: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'November').onSnapshot((data) => {


      setorder_chart(prev => { return { ...prev, NOV: data.size } });

    })
    firebase.firestore().collection('orders').where('month', '==', 'December').onSnapshot((data) => {

      setorder_chart(prev => { return { ...prev, DEC: data.size } });
    })

    // GETTING ORDER STATUSES
    firebase.firestore().collection('orders').where('status', '==', 'pending').onSnapshot((data) => {

      setorder_status_chart(prev => { return { ...prev, pending: data.size } });
    })
    firebase.firestore().collection('orders').where('status', '==', 'approved').onSnapshot((data) => {

      setorder_status_chart(prev => { return { ...prev, approved: data.size } });
    })
    firebase.firestore().collection('orders').where('status', '==', 'production').onSnapshot((data) => {

      setorder_status_chart(prev => { return { ...prev, production: data.size } });
    })
    firebase.firestore().collection('orders').where('status', '==', 'shipped').onSnapshot((data) => {

      setorder_status_chart(prev => { return { ...prev, out_delivery: data.size } });
    })
    firebase.firestore().collection('orders').where('status', '==', 'delivered').onSnapshot((data) => {

      setorder_status_chart(prev => { return { ...prev, delivered: data.size } });
    })



    // FullOrders Data Delivered

    firebase.firestore().collection('orders').where('month', '==', 'January').where('status', '==', 'delivered').onSnapshot((data) => {
      console.log(data.size)
      settotalOrdersData(prev => { return { ...prev, JAN: data.size } });

    })
    firebase.firestore().collection('orders').where('month', '==', 'Febuary').where('status', '==', 'delivered').onSnapshot((data) => {
      console.log(data.size)
      settotalOrdersData(prev => { return { ...prev, FEB: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'March').where('status', '==', 'delivered').onSnapshot((data) => {
      console.log(data.size)
      settotalOrdersData(prev => { return { ...prev, MAR: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'April').where('status', '==', 'delivered').onSnapshot((data) => {

      settotalOrdersData(prev => { return { ...prev, APR: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'May').where('status', '==', 'delivered').onSnapshot((data) => {

      settotalOrdersData(prev => { return { ...prev, MAY: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'June').where('status', '==', 'delivered').onSnapshot((data) => {

      settotalOrdersData(prev => { return { ...prev, JUN: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'July').where('status', '==', 'delivered').onSnapshot((data) => {

      settotalOrdersData(prev => { return { ...prev, JUL: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'August').where('status', '==', 'delivered').onSnapshot((data) => {

      settotalOrdersData(prev => { return { ...prev, AUG: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'September').where('status', '==', 'delivered').onSnapshot((data) => {
      settotalOrdersData(prev => { return { ...prev, SEP: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'October').where('status', '==', 'delivered').onSnapshot((data) => {

      settotalOrdersData(prev => { return { ...prev, OCT: data.size } });
    })
    firebase.firestore().collection('orders').where('month', '==', 'November').where('status', '==', 'delivered').onSnapshot((data) => {


      settotalOrdersData(prev => { return { ...prev, NOV: data.size } });

    })
    firebase.firestore().collection('orders').where('month', '==', 'December').where('status', '==', 'delivered').onSnapshot((data) => {

      settotalOrdersData(prev => { return { ...prev, DEC: data.size } });
    })





    // Beyown Monthly Earnings Data Calculated


    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var beyownRev = []
    //   var reveneuWithTime = []
    //   const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    //   data.docs.forEach(async (doc) => {
    //     // console.log(doc.data()['totalBeyownCostOnOrder']);
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection("monthlyEarnings")
    //       .orderBy("timeStamp", "desc").onSnapshot((data) => {
    //         console.log(data, 'this is data');
    //         data.docs.forEach(async (dataTimestampDoc) => {
    //           await beyownRev.push(dataTimestampDoc.data()['totalBeyownCostOnOrder']);
    //           var EarnDate = {
    //             day: dataTimestampDoc.data()['timeStamp'].toDate().getDate(),
    //             month: month[dataTimestampDoc.data()['timeStamp'].toDate().getMonth()],
    //             year: dataTimestampDoc.data()['timeStamp'].toDate().getFullYear(),
    //             earning: dataTimestampDoc.data()['totalBeyownCostOnOrder']
    //           }
    //           reveneuWithTime.push(EarnDate)
    //           // console.log(EarnDate, 'this is total beyown erarning on 1 product');

    //         })
    //         console.log(beyownRev, 'this is beyown total revenue');
    //         reveneuWithTime.filter((data) => {
    //           // data.
    //         })
    //         const resultJUL = beyownRev.reduce((a, v) => a = a + v, 0)
    //         SetbeyownTotalRevenue(resultJUL)
    //       })




    //     // .where('month', '==', 'Jan').onSnapshot(async (monthdata) => {
    //     //   var monthCostPrice = []


    //     //   await monthdata.docs.forEach((docData) => {
    //     //     monthCostPrice.push(docData.data()['costPrice']);
    //     //   })

    //     //   const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //     //   monthCostPriceJul.push(result);
    //     // const resultJUL = beyowntotalRevenuegen.reduce((a, v) => a = a + v, 0)
    //     // console.log(resultJUL);
    //     //   setTotal_beyown_monthly_earnings(prev => { return { ...prev, JAN: resultJUL } }
    //     //     // { JAN: resultJUL }
    //     //   );
    //     // })

    //   });
    // })
    // let currentYear = new Date().getFullYear();
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Jan ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, FEB: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Feb ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, FEB: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Mar ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, MAR: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Apr ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, APR: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `May ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, MAY: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Jun ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, JUN: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Jul ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, JUL: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Aug ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, AUG: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Sep ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, SEP: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Oct ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, OCT: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Nov ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, NOV: resultJUL } });
    //     })

    //   });
    // })
    // await firebase.firestore().collection('earnings').onSnapshot((data) => {
    //   console.log(data.docs);

    //   var monthCostPriceJul = []
    //   data.docs.forEach(async (doc) => {
    //     await firebase.firestore().collection('earnings').doc(doc.id).collection('monthlyEarnings').where('month', '==', `Dec ${currentYear}`).onSnapshot(async (monthdata) => {
    //       var monthCostPrice = []


    //       await monthdata.docs.forEach((docData) => {
    //         monthCostPrice.push(docData.data()['totalBeyownCostOnOrder']);
    //       })

    //       const result = await monthCostPrice.reduce((a, v) => a = a + v, 0)

    //       monthCostPriceJul.push(result);

    //       const resultJUL = monthCostPriceJul.reduce((a, v) => a = a + v, 0)
    //       setTotal_beyown_monthly_earnings(prev => { return { ...prev, DEC: resultJUL } });
    //     })

    //   });
    // })



  }




  const BeyownEarnings = async () => {
    firebase.firestore().collection('earnings').doc('Beyown').collection('totalEarnings').onSnapshot(async (edata) => {
      const monthsALL = [];
      const totalEarningsBeyown = [];
      const totalSalesBeyown = [];
      await edata.docs.map(async (month) => {
        //all months earning
        monthsALL.push(month?.id);
        //
        totalEarningsBeyown.push(month?.data()['totalEarningOnOrders']);
        totalSalesBeyown.push(month?.data()['totalSales'])
      });

      console.log(totalSalesBeyown, 'this is sales');
      setbeyown_monthly_Sales(totalSalesBeyown.reverse())

      const addAllMonthsEarningsDocs = await totalEarningsBeyown.reduce((a, v) => a = a + v, 0);
      SetbeyownTotalRevenue(addAllMonthsEarningsDocs);

      const reverSeArray = monthsALL.reverse();
      setTotal_beyown_monthly_earnings_months(reverSeArray);
      const resultTotalSales = await totalSalesBeyown.reduce((a, v) => a = a + v, 0)
      Setbeyown_Total_sales(resultTotalSales)

      const reverSeArraySalesMOnthly = totalEarningsBeyown.reverse();
      setTotal_beyown_monthly_earnings(reverSeArraySalesMOnthly);

    })
  }

  const GetAdsDataRev = async () => {
    firebase.firestore().collection('Ads').onSnapshot(async (adsDoc) => {
      const AdsRev = []
      await adsDoc.docs.forEach((data) => {
        var adsPaymnt = data.data()['amountPayment']
        AdsRev.push(adsPaymnt);
      })
      const resultAllAds = await AdsRev.reduce((a, v) => a = a + v, 0)
      setAdsRevDatesEarning(resultAllAds)

      // setAdsRevDates(setArray)

    })
  }
  useEffect(() => {
    getData()
    BeyownEarnings();
    GetAdsDataRev();

  }, []);
  const [bigChartData, setbigChartData] = React.useState("data1");
  const setBgChartData = (name) => {
    setbigChartData(name);
  };







  let chart1_2_options = {
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    tooltips: {
      backgroundColor: "#f5f5f5",
      titleFontColor: "#333",
      bodyFontColor: "#666",
      bodySpacing: 4,
      xPadding: 12,
      mode: "nearest",
      intersect: 0,
      position: "nearest"
    },
    responsive: true,
    scales: {
      x: [{
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent"
        },
        ticks: {
          padding: 20,
          fontColor: "#9a9a9a"
        }
      }],
      y: [
        {
          barPercentage: 1.6,
          gridLines: {
            drawBorder: false,
            color: "rgba(29,140,248,0.0)",
            zeroLineColor: "transparent"
          },
          ticks: {
            suggestedMin: 60,
            suggestedMax: 125,
            padding: 20,
            fontColor: "#9a9a9a"
          }
        }
      ]
    }
    // scales: {
    //   // yAxes: [
    // {
    //   barPercentage: 1.6,
    //   gridLines: {
    //     drawBorder: false,
    //     color: "rgba(29,140,248,0.0)",
    //     zeroLineColor: "transparent"
    //   },
    //   ticks: {
    //     suggestedMin: 60,
    //     suggestedMax: 125,
    //     padding: 20,
    //     fontColor: "#9a9a9a"
    //   }
    //   //   }
    //   // ],
    //   // xAxes: [
    // {
    //   barPercentage: 1.6,
    //   gridLines: {
    //     drawBorder: false,
    //     color: "rgba(29,140,248,0.1)",
    //     zeroLineColor: "transparent"
    //   },
    //   ticks: {
    //     padding: 20,
    //     fontColor: "#9a9a9a"
    //   }
    // }
    //   // ]
    // }
  };


  const Labels = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC"]







  let Orders = {
    data: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
      gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

      return {
        labels: Labels,
        datasets: [
          {
            label: "Total Orders",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#1f8ef1",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#1f8ef1",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: [
              order_chart.JAN, order_chart.FEB, order_chart.MAR, order_chart.APR, order_chart.MAY, order_chart.JUN, order_chart.JUL, order_chart.AUG, order_chart.SEP, order_chart.OCT, order_chart.NOV, order_chart.DEC
            ],
          },

        ]
      };
    },
    options: chart1_2_options
  };


  let OrderStatuses = {
    data: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(72,72,176,0.1)");
      gradientStroke.addColorStop(0.4, "rgba(72,72,176,0.0)");
      gradientStroke.addColorStop(0, "rgba(119,52,169,0)"); //purple colors

      return {
        labels: ["Pending", "Approved", "Production", "Out For Delivery", "Delivered"],
        datasets: [
          {
            label: "Status",
            fill: true,
            backgroundColor: gradientStroke,
            hoverBackgroundColor: gradientStroke,
            borderColor: "#d048b6",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            data: [order_status_chart.pending, order_status_chart.approved, order_status_chart.production, order_status_chart.out_delivery, order_status_chart.delivered]
          }
        ]
      };
    },
    options: {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      tooltips: {
        backgroundColor: "#f5f5f5",
        titleFontColor: "#333",
        bodyFontColor: "#666",
        bodySpacing: 4,
        xPadding: 12,
        mode: "nearest",
        intersect: 0,
        position: "nearest"
      },
      responsive: true,
      scales: {
        yAxes: [
          {
            gridLines: {
              drawBorder: false,
              color: "rgba(225,78,202,0.1)",
              zeroLineColor: "transparent"
            },
            ticks: {
              // suggestedMin: 10,
              // suggestedMax: 120,
              padding: 20,
              fontColor: "#9e9e9e"
            }
          }
        ],
        xAxes: [
          {
            gridLines: {
              drawBorder: false,
              color: "rgba(225,78,202,0.1)",
              zeroLineColor: "transparent"
            },
            ticks: {
              padding: 20,
              fontColor: "#9e9e9e"
            }
          }
        ]
      }
    }
  };




  let OrderSales = {
    data: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(72,72,176,0.1)");
      gradientStroke.addColorStop(0.4, "rgba(72,72,176,0.0)");
      gradientStroke.addColorStop(0, "rgba(119,52,169,0)"); //purple colors

      return {
        labels: [],
        datasets: [
          {
            label: "Status",
            fill: true,
            backgroundColor: gradientStroke,
            hoverBackgroundColor: gradientStroke,
            borderColor: "#d048b6",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            data: day
          }
        ]
      };
    },
    options: {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      tooltips: {
        backgroundColor: "#f5f5f5",
        titleFontColor: "#333",
        bodyFontColor: "#666",
        bodySpacing: 4,
        xPadding: 12,
        mode: "nearest",
        intersect: 0,
        position: "nearest"
      },
      responsive: true,
      scales: {
        yAxes: [
          {
            beginAtZero: true,
            gridLines: {
              drawBorder: false,
              color: "rgba(225,78,202,0.1)",
              zeroLineColor: "transparent"
            },
            ticks: {
              // suggestedMin: 10,
              // suggestedMax: 120,
              padding: 20,
              fontColor: "#9e9e9e"
            }
          }
        ],
        xAxes: [
          {
            type: 'time',
            time: {
              unit: 'day',
              displayFormats: {
                quarter: 'MMM D'
              }
            },
            gridLines: {
              drawBorder: false,
              color: "rgba(225,78,202,0.1)",
              zeroLineColor: "transparent"
            },
            ticks: {
              padding: 20,
              fontColor: "#9e9e9e"
            }
          }
        ]
      }
    }
  };
  let currentYear = new Date().getFullYear();

  //BeyownEarnings Chart
  let chartExample1 = {

    data1: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
      gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

      return {
        labels:
          beyown_monthly_earnings_months

        ,
        datasets: [
          {
            label: "Earned",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#1f8ef1",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#1f8ef1",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data:
              beyown_monthly_earnings
            // beyown_monthly_earnings.JAN, beyown_monthly_earnings.FEB, beyown_monthly_earnings.MAR, beyown_monthly_earnings.APR, beyown_monthly_earnings.MAY, beyown_monthly_earnings.JUN, beyown_monthly_earnings.JUL, beyown_monthly_earnings.AUG, beyown_monthly_earnings.SEP, beyown_monthly_earnings.OCT, beyown_monthly_earnings.NOV, beyown_monthly_earnings.DEC

          }
        ]
      };
    },
    data2: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
      gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

      return {
        labels:

          beyown_monthly_earnings_months
        ,
        datasets: [
          {
            label: "Sale in AED",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#1f8ef1",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#1f8ef1",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: beyown_monthly_Sales
          }
        ]
      };
    },
    data3: (canvas) => {
      let ctx = canvas.getContext("2d");

      let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

      gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
      gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
      gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

      return {
        labels: [
          // AdsRevDates

        ],
        datasets: [
          {
            label: "My First dataset",
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#1f8ef1",
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: "#1f8ef1",
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#1f8ef1",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: []
          }
        ]
      };
    },
    options: chart1_2_options
  };





  let DateLabels = [];

  const day = [
    { x: Date.parse('2021-11-02'), y: 18 },
    { x: Date.parse('2021-11-03'), y: 9 },
    { x: Date.parse('2021-11-04'), y: 23 },
    { x: Date.parse('2021-11-05'), y: 2 },
  ];





  // GET SALES IN FILTER DATES








  useEffect(() => {

    firebase.firestore()
      .collection("orders").where('status', '==', 'delivered').where('isCompleted', '==', true).onSnapshot((orders) => {
        var total_amount = [];
        // console.log(snapdata);
        orders.forEach((order_amount) => {
          total_amount.push(order_amount.data()['amount']);

        })
        console.log(total_amount);
        const result = total_amount.reduce((a, v) => a = a + v, 0)
        console.log(result);

        settotal_Sales(result);
      })



  }, [])





  function ordersHistoryMonthly(orders = []) {
    let myorders = [];
    let totalPerMonth = [];
    let startDate = getMinDate(orders);
    let endDate = getMaxDate(orders);
    let labels = getDates(startDate, endDate, "MMMM YYYY", "month");


    console.log(labels)

    labels.forEach((m) => {

      let totalIncome = 0;
      orders.map((e) => {
        myorders.push(e.data())
        console.log(e.data());

      });
      console.log(myorders)

      myorders.forEach((o, i) => {


        let oDate = moment(new Date(o.date.seconds * 1000), "DD-MM-YYYY HH:mm");
        console.log(oDate.format("DD MMMM YYYY"))

        if (oDate.format("MMMM YYYY") === m)
          console.log('month years');
        totalIncome += Number(o.amount);
      });
      totalPerMonth.push(totalIncome);
      console.log(totalIncome);
      settotal_Sales(totalIncome);

    });
  }



  function getDates(startDate, stopDate, format = "DD-MM-YYYY", unit = "days") {
    console.log('this is dates');
    let dateArray = [];
    let currentDate = moment(startDate);
    console.log(currentDate);
    const stop = moment(stopDate);
    console.log(stop);

    while (currentDate <= stop) {
      dateArray.push(moment(currentDate).format(format));
      currentDate = moment(currentDate).add(1, unit);
    }

    console.log(dateArray);
    return dateArray;
  }


  function getMinDate(orders) {
    var start_date = [];
    orders.map((e) => { start_date.push(e.data()) });
    let date = moment(new Date());
    if (start_date) {

      if (start_date[0]) {
        date = moment(new Date(start_date[0].date.seconds * 1000));
      }
    }
    return date;
  }

  function getMaxDate(orders) {
    var end_date = [];
    orders.map((e) => { end_date.push(e.data()) });
    let date = moment(new Date());
    if (end_date) {
      if (end_date[end_date.length - 1]) {
        date = moment(
          new Date(end_date[end_date.length - 1].date.seconds * 1000)
        );
      }
    }
    return date;
  }


  useEffect(() => {
    const initClient = () => {
      gapi.auth2.init({
        clientId: clientId,
        scope: 'https://www.googleapis.com/auth/analytics.readonly',
        plugin_name: "beyown"
      });
    };
    gapi.load('client:auth2', initClient);

  });

  const { profile, ProfileAdded, clientId, setToken } = useContext(GoogleLoginContext);


  const onSuccess = (res) => {
    // setProfile(res.profileObj);
    console.log(res.profileObj);
    ProfileAdded(res.profileObj)
    console.log('logged in');
    // console.log(myprofile.imageUrl);
    toast.success('Google Analytics has been enabled Successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",

    })
    setToken(res.tokenObj.access_token);
    console.log(res.tokenObj.access_token);



  };

  const onFailure = (err) => {
    console.log('failed', err);
    toast.warning(err, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",

    })

  };



  return (
    <>
      <div className="content">
        month: {beyown_monthly_earnings_months},Earning:{beyown_monthly_earnings}
        {profile?.email == 'Support@beyown.com' ? <div className="d-flex p-2"><p>Google Analytics:</p><p className='text-success ml-2'>Connected</p></div> : (<div className="d-flex p-2"><p>Google Analytics:</p><p className='text-warning ml-2'>Not Connected</p><div className="my-3 d-flex justify-content-around align-items-center shadow-lg p-3">
          <GoogleLogin
            clientId={clientId}
            buttonText="Sign in with Google"
            onSuccess={onSuccess}
            onFailure={onFailure}
            cookiePolicy={'single_host_origin'}
            isSignedIn={true}
          />
        </div> </div>)}

        <Row>
          <Col xs="12">

            <Card className="card-chart shadow-lg border rounded" style={{ borderRadius: '20px', border: '0.5em solid' }}>
              <CardHeader>
                <Row>
                  <Col className="text-left" sm="6">
                    <h5 className="card-category"></h5>
                    <CardTitle tag="h2">Performance</CardTitle>
                    {/* <div className="d-flex justify-content-between">
                      <div >
                        <CustomDatePicker
                          placeholder={"Start date"}
                          date={startDate}
                          handleDateChange={(date) => setStartDate(date)}
                        />
                      </div>
                      <CustomDatePicker
                        placeholder={"End date"}
                        date={endDate}
                        handleDateChange={(date) => setEndDate(date)}
                      />
                    </div> */}
                  </Col>
                  <Col sm="6">
                    <ButtonGroup
                      className="btn-group-toggle float-right"
                      data-toggle="buttons"
                    >
                      <Button
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data1"
                        })}
                        color="info"
                        id="0"
                        size="sm"
                        onClick={() => setBgChartData("data1")}
                      >

                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Earnings
                        </span>

                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-single-02" />
                        </span>
                      </Button>

                      <Button
                        color="info"
                        id="1"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data2"
                        })}
                        onClick={() => setBgChartData("data2")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Sales
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-gift-2" />
                        </span>
                      </Button>
                      {/* <Button
                        color="info"
                        id="2"
                        size="sm"
                        tag="label"
                        className={classNames("btn-simple", {
                          active: bigChartData === "data3"
                        })}
                        onClick={() => setBgChartData("data3")}
                      >
                        <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                          Ads Rev
                        </span>
                        <span className="d-block d-sm-none">
                          <i className="tim-icons icon-tap-02" />
                        </span>
                      </Button> */}
                    </ButtonGroup>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={chartExample1[bigChartData]}
                    options={chartExample1.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>

          <Col lg="4">

            <CountriesReport viewID='' />

          </Col>
          <Col lg="8">
            <DayVisitsReport title={"Active Users"} />
          </Col>


        </Row>

        <Row>


          <Col lg="4">

            <div className='d-flex flex-column  '>
              <Card className="card-chart shadow-lg border rounded ">
                <CardHeader>
                  <p className="card-category font-weight-bolder">Total Revenue </p>
                  <CardTitle tag="h2">
                    <i className="tim-icons icon-single-02 " />
                    {/* <Link to='/admin/Total-Orders' id="displayUsers">   */}
                    {formatter.format(beyownTotalRevenue)} AED
                    {/* </Link> */}
                  </CardTitle>
                </CardHeader>

              </Card>
              <Card className="card-chart shadow-lg border rounded ">
                <CardHeader>
                  <p className="card-category font-weight-bolder">Total Ads Revenue </p>
                  <CardTitle tag="h2">
                    <i className="tim-icons icon-single-02" />    {formatter.format(AdsRevDatesEarning)} AED
                  </CardTitle>
                </CardHeader>

              </Card>
              <Card className="card-chart shadow-lg border rounded">
                <CardHeader>
                  <p className="card-category font-weight-bolder"> Sales</p>
                  <CardTitle tag="h2">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex">
                        <i className="tim-icons icon-delivery-fast text-primary" />
                        <p>{formatter.format(beyown_total_sales)} AED</p>
                      </div>
                      <div>
                        <div>

                          {/* <button className='btn btn-sm btn-light'>Daily Sales</button>
                        <button className='btn btn-sm btn-light'>Monthly Sales</button> */}
                        </div>
                      </div>
                    </div>
                  </CardTitle>
                </CardHeader>

                {/* <CardBody>
                <div className="chart-area">
                  <Line
                    data={OrderSales.data}
                    options={OrderSales.options}
                    height={300}
                  />

                </div>

              </CardBody> */}
              </Card>

            </div>
          </Col>
          <Col lg="4">
            <SourceReport />
          </Col>
          <Col lg="4">
            <DevicesReport />
          </Col>


        </Row>
        <Row>


          <Col lg="4">
            <Card className="card-chart shadow-lg border rounded">
              <CardHeader>
                <h5 className="card-category">Total Orders</h5>
                <CardTitle tag="h3">
                  <Link to='/admin/Total-Orders'> <i className="tim-icons icon-bag-16 text-info" /> {formatter.format(total_orders)}</Link>
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={Orders.data}
                    options={Orders.options}
                    height={300}

                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4">
            <Card className="card-chart shadow-lg border rounded">
              <CardHeader>
                <h5 className="card-category">Orders Status</h5>
                <CardTitle tag="h3">
                  <Link to='/admin/Total-Orders'> <i className="tim-icons icon-bag-16 text-info" /> {formatter.format(total_orders)}</Link>
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Bar
                    data={OrderStatuses.data}
                    options={OrderStatuses.options}
                    height={300}

                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="4">
            <Card className="card-chart shadow-lg border rounded ">
              <CardHeader>
                <p className="card-category font-weight-bolder">Total Users</p>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-single-02" />  <Link to='/admin/users/total-beyown-users' id="displayUsers">  {formatter.format(total_users)}</Link>
                </CardTitle>
              </CardHeader>

            </Card>
            <Card className="card-chart shadow-lg border rounded ">
              <CardHeader>
                <p className="card-category font-weight-bolder">Total Products</p>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-single-02" />  <Link to='/admin/Total-Products' id="displayUsers">  {formatter.format(total_products)}</Link>
                </CardTitle>
              </CardHeader>

            </Card>
            <Card className="card-chart shadow-lg border rounded ">
              <CardHeader>
                <p className="card-category font-weight-bolder">Total Orders </p>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-single-02" />  <Link to='/admin/Total-Orders' id="displayUsers">  {formatter.format(total_orders)}</Link>
                </CardTitle>
              </CardHeader>

            </Card>
          </Col>
          {/* <Col lg="4">
            <Card className="card-chart shadow-lg border rounded">
              <CardHeader>
                <h5 className="card-category">Completed Tasks</h5>
                <CardTitle tag="h3">
                  <i className="tim-icons icon-send text-success" /> 12,100K
                </CardTitle>
              </CardHeader>
              <CardBody>
                <div className="chart-area">
                  <Line
                    data={chartExample4.data}
                    options={chartExample4.options}
                  />
                </div>
              </CardBody>
            </Card>
          </Col> */}
        </Row>
        <Row>
          {/* <Col lg="6" md="12"> */}
          {/* <Card className="card-tasks shadow-lg border rounded"> */}
          {/* <CardHeader>
                <h6 className="title d-inline">Tasks(5)</h6>
                <p className="card-category d-inline"> today</p>
                <UncontrolledDropdown>
                  <DropdownToggle
                    caret
                    className="btn-icon"
                    color="link"
                    data-toggle="dropdown"
                    type="button"
                  >
                    <i className="tim-icons icon-settings-gear-63" />
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="dropdownMenuLink" right>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Action
                    </DropdownItem>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Another action
                    </DropdownItem>
                    <DropdownItem
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Something else
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardHeader> */}
          {/* <CardBody>
                <div className="table-full-width table-responsive">
                  <Table>
                    <tbody>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Update the Documentation</p>
                          <p className="text-muted">
                            Dwuamish Head, Seattle, WA 8:47 AM
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip636901683"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip636901683"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input
                                defaultChecked
                                defaultValue=""
                                type="checkbox"
                              />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">GDPR Compliance</p>
                          <p className="text-muted">
                            The GDPR is a regulation that requires businesses to
                            protect the personal data and privacy of Europe
                            citizens for transactions that occur within EU
                            member states.
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip457194718"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip457194718"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Solve the issues</p>
                          <p className="text-muted">
                            Fifty percent of all respondents said they would be
                            more likely to shop at a company
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip362404923"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip362404923"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Release v2.0.0</p>
                          <p className="text-muted">
                            Ra Ave SW, Seattle, WA 98116, SUA 11:19 AM
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip818217463"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip818217463"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Export the processed files</p>
                          <p className="text-muted">
                            The report also shows that consumers will not easily
                            forgive a company once a breach exposing their
                            personal data occurs.
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip831835125"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip831835125"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <FormGroup check>
                            <Label check>
                              <Input defaultValue="" type="checkbox" />
                              <span className="form-check-sign">
                                <span className="check" />
                              </span>
                            </Label>
                          </FormGroup>
                        </td>
                        <td>
                          <p className="title">Arival at export process</p>
                          <p className="text-muted">
                            Capitol Hill, Seattle, WA 12:34 AM
                          </p>
                        </td>
                        <td className="td-actions text-right">
                          <Button
                            color="link"
                            id="tooltip217595172"
                            title=""
                            type="button"
                          >
                            <i className="tim-icons icon-pencil" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip217595172"
                            placement="right"
                          >
                            Edit Task
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </CardBody> */}
          {/* </Card> */}
          {/* </Col> */}
          <Col lg="12" md="12">
            <PivotTable />
          </Col>
        </Row>
      </div>
      <ToastContainer />

    </>
  );
}

export default Dashboard;
